module.exports = __webpack_public_path__ + "static/media/KMH_5243.e5479bcf.jpg";